import axios from "axios";
import config from "../../config";
import { SearchAddressModel } from "./types";

const apiUrl = config.api;

export const getAddresses = async (
  postcode: string,
): Promise<SearchAddressModel> => {
  const response = await axios.get<SearchAddressModel>(
    `${apiUrl}/address/${postcode}`,
    {
      withCredentials: true,
    },
  );

  return response.data;
};

export default getAddresses;
